import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Icon, Typography } from 'shared/ui'
import { type TwoFaModalStore } from 'entities/Auth/ui/TwoFaModal'
import { type ITwoFaMethod } from 'entities/Auth/ui/TwoFaModal/store/type'
import styles from './styles.module.scss'

type IProps = {
  item: ITwoFaMethod
  store: TwoFaModalStore
}

export const MethodItem = observer(({ item, store }: IProps) => {
  const { twoFaMethod, setTwoFaMethod } = store

  const isActive = twoFaMethod?.type === item.type

  return (
    <div
      className={classNames(styles.item, { [styles.active]: isActive })}
      onClick={() => setTwoFaMethod(item)}
    >
      <div className={styles.icon}>
        <Icon fontSize={16} icon={item.icon} />
      </div>
      <div className={styles.content}>
        <Typography
          color={'var(--content-primary-primary)'}
          ariaLabel={`twoFaMethodTitle-${item.type}`}
          variant='body-md-regular'
        >
          {item.title}
        </Typography>
        <Typography
          color={'var(--content-primary-tertiary)'}
          ariaLabel={`twoFaMethodDesc-${item.type}`}
          variant='body-sm-regular'
        >
          {item.desc}
        </Typography>
      </div>
    </div>
  )
})
